import { Route, Routes } from 'react-router';

import { HomePage } from '@/pages/home-page';
import { GivePage } from '@/pages/give-page';
import { RegisterPage } from '@/pages/register-page';

export const App = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/:churchSlug/register/:programId" element={<RegisterPage />} />
    <Route path="/:churchSlug/:linkSlug" element={<GivePage />} />
  </Routes>
);
